// Enum value lists mirrored from server models (human-readable labels)

export const MUSCLE_GROUPS = [
  // Legacy broad groups
  "Chest",
  "Back",
  "Shoulders",
  "Biceps",
  "Triceps",
  "Forearms",
  "Abs",
  "Obliques",
  "Lower Back",
  "Quads",
  "Hamstrings",
  "Glutes",
  "Calves",
  "Hip Flexors / Adductors",
  // Lower body (granular)
  "Gluteus maximus",
  "Gluteus medius",
  "Gluteus minimus",
  "Quadriceps",
  "Adductors",
  "Hip flexors",
  "Gastrocnemius",
  "Soleus",
  "Tibialis anterior",
  "Tibialis posterior",
  "Peroneals / fibularis group",
  "Foot intrinsics",
  // Trunk / core (granular)
  "Rectus abdominis",
  "Transverse abdominis",
  "Quadratus lumborum",
  "Erector spinae",
  "Multifidi",
  "Deep core stabilizers",
  // Upper body (granular)
  "Pectoralis major",
  "Pectoralis minor",
  "Latissimus dorsi",
  "Deltoids",
  "Anterior deltoid",
  "Lateral deltoid",
  "Posterior deltoid",
  "Biceps brachii",
  "Brachialis",
  "Brachioradialis",
  "Triceps brachii",
  "Forearms / grip",
  // Scapular / shoulder stabilizers
  "Serratus anterior",
  "Upper trapezius",
  "Middle trapezius",
  "Lower trapezius",
  "Rhomboids",
  "Rotator cuff",
  "Supraspinatus",
  "Infraspinatus",
  "Teres minor",
  "Subscapularis",
  "Shoulder stabilizers",
] as const;

export type MuscleGroup = (typeof MUSCLE_GROUPS)[number];

export const MOVEMENT_PATTERNS = [
  "Push",
  "Pull",
  "Squat",
  "Hinge",
  "Lunge / Step",
  "Core",
  "Locomotion",
] as const;

export type MovementPattern = (typeof MOVEMENT_PATTERNS)[number];

export const MUSCLE_ACTIONS = [
  // Contraction type
  "Concentric",
  "Eccentric",
  "Isometric",
  "Plyometric",
  // Hip
  "Hip extension",
  "Hip flexion",
  "Hip abduction",
  "Hip adduction",
  "Hip external rotation",
  "Hip internal rotation",
  // Knee / ankle
  "Knee extension",
  "Knee flexion",
  "Ankle dorsiflexion",
  "Ankle plantarflexion",
  // Shoulder
  "Shoulder flexion",
  "Shoulder extension",
  "Shoulder abduction",
  "Shoulder adduction",
  "Shoulder external rotation",
  "Shoulder internal rotation",
  // Scapular
  "Scapular protraction",
  "Scapular retraction",
  "Scapular upward rotation",
  "Scapular depression",
  // Elbow / wrist
  "Elbow flexion",
  "Elbow extension",
  "Wrist flexion",
  "Wrist extension",
  "Grip / loaded hold",
  // Core / spine
  "Anti-extension",
  "Anti-flexion",
  "Anti-rotation",
  "Anti-lateral flexion",
  "Trunk rotation",
  "Trunk flexion",
  "Trunk extension",
  "Lateral flexion",
  // Integrated / functional
  "Load carriage",
  "Gait / locomotion",
  "Force transfer",
  "Perturbation control",
  "Postural control",
  "Balance strategy",
  "Landing / deceleration",
  "Acceleration",
] as const;

export type MuscleAction = (typeof MUSCLE_ACTIONS)[number];

export const DIFFICULTY = [
  "Beginner",
  "Intermediate",
  "Advanced",
  "Expert",
  "Pro",
] as const;

export type Difficulty = (typeof DIFFICULTY)[number];
